import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/geopin.svg")